import { faChartBar, faCubes, faTools, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { ROLE_ADMIN, ROLE_SUPERADMIN } from './constants';
import AuthLayout from './layouts/Auth';

import AppsMenu from 'containers/AppsMenu';
import SubscriptionLayout from './layouts/SubscriptionLayout';
import CheckoutLayout from './layouts/CheckoutLayout';

const routes = [
  {
    path: '/',
    noAuth: true,
    noMenu: true,
    layout: AuthLayout,
    pageComponent: 'LandingPage',
  },
  {
    path: '/login',
    noAuth: true,
    noMenu: true,
    layout: AuthLayout,
    pageComponent: 'LoginPage',
  },
  {
    path: '/forgot-password',
    noAuth: true,
    noMenu: true,
    layout: AuthLayout,
    pageComponent: 'ForgotPasswordPage',
  },
  {
    path: '/forgot-password-confirmed',
    noAuth: true,
    noMenu: true,
    layout: AuthLayout,
    pageComponent: 'ForgotPasswordConfirmedPage',
  },
  {
    path: '/reset-password',
    noAuth: true,
    noMenu: true,
    layout: AuthLayout,
    pageComponent: 'ResetPasswordPage',
  },
  {
    path: '/reset-password-success',
    noAuth: true,
    noMenu: true,
    layout: AuthLayout,
    pageComponent: 'ResetPasswordSuccessPage',
  },
  {
    path: '/register',
    noAuth: true,
    noMenu: true,
    layout: AuthLayout,
    pageComponent: 'RegisterPage',
  },
  {
    path: '/register-success',
    noAuth: true,
    noMenu: true,
    layout: AuthLayout,
    pageComponent: 'RegisterSuccessPage',
  },
  {
    path: '/verify',
    noAuth: true,
    noMenu: true,
    layout: AuthLayout,
    pageComponent: 'VerifyPage',
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: faChartBar,
    isHome: true,
    pageComponent: 'DashboardPage',
  },
  {
    path: '/apps',
    name: 'Apps Management',
    icon: faCubes,
    pageComponent: 'AppsPage',
    role: [ROLE_SUPERADMIN, ROLE_ADMIN],
  },
  {
    path: '/beacons-management/app',
    name: 'Beacons Management',
    beaconIcon: true,
    pageComponent: 'BeaconAppsPage',
    role: [ROLE_SUPERADMIN, ROLE_ADMIN],
  },
  {
    path: '/beacons-management/app/:id',
    noMenu: true,
    pageComponent: 'BeaconsPage',
    role: [ROLE_SUPERADMIN, ROLE_ADMIN],
  },

  {
    path: '/create-custom-plan',
    name: 'Create Custom Plan',
    icon: faDollarSign,
    pageComponent: 'CreateCustomPLanPage',
    role: [ROLE_SUPERADMIN],
  },
  {
    path: '/sdk',
    name: 'Mobile App SDK',
    icon: faTools,
    pageComponent: 'SdkPage',
  },
  // stripe - Subscription
  {
    path: '/subscription',
    noMenu: true,
    layout: SubscriptionLayout,
    pageComponent: 'SubscriptionPage',
    role: [ROLE_SUPERADMIN, ROLE_ADMIN],
  },
  {
    path: '/subscription/:id/checkout',
    noMenu: true,
    layout: CheckoutLayout,
    pageComponent: 'CheckoutPage',
  },
  //
  {
    path: '/apps/create',
    noMenu: true,
    pageComponent: 'CreateAppPage',
    role: [ROLE_SUPERADMIN, ROLE_ADMIN],
  },
  {
    path: '/apps/:id/edit',
    noMenu: true,
    pageComponent: 'EditAppPage',
    role: [ROLE_SUPERADMIN, ROLE_ADMIN],
  },
  {
    path: '/apps/:id',
    header: 'Apps',
    menuComponent: AppsMenu,
    children: [
      {
        path: '/apps/:id/activity',
        name: 'Customer Activity',
        pageComponent: 'AppActivityPage',
      },
      {
        path: '/apps/:id/entry-exit',
        name: 'Entry-Exit by User',
        pageComponent: 'AppEntryExitPage',
        role: [ROLE_SUPERADMIN],
      },
      {
        path: '/apps/:id/foot-traffic',
        name: 'Foot Traffic Engagements',
        pageComponent: 'AppFootTrafficPage',
      },
      {
        path: '/apps/:id/checkin-details',
        name: 'Check-ins',
        pageComponent: 'AppCheckinDetailsPage',
      },
      {
        path: '/apps/:id/session-details',
        name: 'Session Details',
        pageComponent: 'AppSessionDetailsPage',
      },
    ],
  },
];

export default routes;

const filterRoutes = (inputRoutes, userRole) => {
  let filtered = [];
  inputRoutes.forEach(r => {
    let hasAccess = false;
    if (!r.role || !userRole) {
      hasAccess = true;
    } else if (typeof r.role == 'string') {
      hasAccess = r.role === userRole;
    } else if (Array.isArray(r.role)) {
      for (let i = 0; i < r.role.length; i++) {
        if (r.role[i] === userRole) {
          hasAccess = true;
          break;
        }
      }
    }

    if (hasAccess) {
      let newroute = { ...r };
      if (newroute.children) {
        newroute.children = filterRoutes(newroute.children, userRole);
      }
      filtered.push(newroute);
    }
  });
  return filtered;
};

export const routesByRole = userRole => filterRoutes(routes, userRole);
